import React from 'react';
import { alpha, useTheme } from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import handleOpenWhatsApp from 'services/whatsappService';
import { WHATSAPP_DEFAULT, WHATSAPP_PHONE } from '../cherryWebContent';

const WhatsAppFloat = () => {
  const theme = useTheme();

  return (
    <Tooltip title="Cotizar por WhatsApp" placement="left">
      <Fab
        color="secondary"
        aria-label="WhatsApp"
        onClick={() => handleOpenWhatsApp(null, WHATSAPP_DEFAULT, WHATSAPP_PHONE)}
        sx={{
          position: 'fixed',
          right: { xs: 16, md: 28 },
          bottom: { xs: 16, md: 28 },
          zIndex: 1400,
          width: 58,
          height: 58,
          boxShadow: `0 12px 32px ${alpha(theme.palette.secondary.main, 0.45)}`,
          animation: 'cw-pulse 2.4s ease-in-out infinite',
          '@keyframes cw-pulse': {
            '0%, 100%': { transform: 'scale(1)' },
            '50%': { transform: 'scale(1.06)' },
          },
          '&:hover': {
            bgcolor: theme.palette.secondary.dark,
          },
        }}
      >
        <WhatsAppIcon sx={{ fontSize: 28 }} />
      </Fab>
    </Tooltip>
  );
};

export default WhatsAppFloat;
